import { gql } from '@apollo/client';
import { DriverVerificationFiltersTypeInput } from './getDriverVerificationQueries';

export const GET_DRIVER_VERIFICATION_TAB_COUNTS = gql`
    query GetDriverVerificationTabCounts($filters: DriverVerificationFiltersTypeInput) {
        getDriverVerificationTabCounts(filters: $filters) {
            pending
            approved
            rejected
        }
    }
`;

export interface GetDriverVerificationTabCountsResponse {
    getDriverVerificationTabCounts: {
        pending: number;
        approved: number;
        rejected: number;
    };
}

export interface GetDriverVerificationTabCountsInput {
    filters?: DriverVerificationFiltersTypeInput;
}

